<template>
  <div class="flex items-center justify-center h-full w-full">
    <empty-view text="Variables simplify the management of frequently used information, such as phone numbers and opening hours."
                image-name="variablesEmpty"
    >
      <slot/>
    </empty-view>
  </div>
</template>

<script>
import EmptyView from '@/components/editor/EmptyView.vue'

export default {
  name: 'VariablesEmptyView',

  components: { EmptyView }
}
</script>
